<div class="side-menu-container" [class.mobile-open]="isSidebarOpen" [class.rtl]="languageService.currentLanguage=='ar'">
    <!-- Sidebar -->
    <aside class="sidebar col-2" [class.offcanvas]="!isMediumOrAbove" [class.open]="isSidebarOpen">
  <div class="logo">
    <img [src]="logoUrl" [alt]=" ('Tenant.Company_Name' | translate) + 'Logo'" />
</div>
  
  <nav class="menu mx-3">
    <a class="menu-item" routerLinkActive="active" [routerLink]="['/opportunities']">
  <span><img src="assets/images/SARIcon.svg" class="currency-img" alt=""></span>
            <span>{{ 'Home.OPPORTUNITIES' | translate }}</span>
    </a>
    <a class="menu-item" routerLinkActive="active" [routerLink]="['/investment']">
      <i class="ri-file-chart-line"></i>
            <span>{{ 'Home.INVESTMENTS' | translate }}</span>
    </a>
    <a class="menu-item" routerLinkActive="active" [routerLink]="['/wallet']">
      <i class="ri-wallet-line"></i>
            <span>{{ 'Home.WALLET' | translate }}</span>
    </a>
    <a class="menu-item" routerLinkActive="active" [routerLink]="['/profile']">
      <i class="ri-user-settings-line"></i>
      <span>{{ 'Home.PROFILE' | translate }}</span>
    </a>  
    <a class="menu-item" routerLinkActive="active" [routerLink]="['/faq/DetailedSupportAndHelp']">
      <i class="ri-customer-service-2-line"></i>
     <span>{{ 'FAQ.SUPPORT_AND_HELP' | translate }}</span>
    </a>
  </nav>
    </aside>
  
    <!-- Backdrop for mobile -->
    <div class="backdrop" *ngIf="!isMediumOrAbove && mobileSidebarOpen" (click)="closeSidebar()"></div>

    <!-- Main Content -->
    <section class="main-content">
      <header class="header">
    <button class="menu-toggle d-md-none" type="button" (click)="toggleSidebar()">
      <i class="ri-menu-2-line primary_color font-size-4 font-weight-700"></i>
    </button>
    <div class="header-right">
     <div class="dropdown d-inline-block">
  <button class="nav-link cursor-pointer dropdown-toggle" 
          id="langDropdown" 
          data-bs-toggle="dropdown">
    <i class="ri-global-line"></i>
 {{ languageService.currentLanguage === 'ar' ? 'العربيه' : 'English' }}
  </button>

  <ul class="dropdown-menu" aria-labelledby="langDropdown">
    <li>
      <a class="dropdown-item" 
         *ngIf="languageService.currentLanguage !== 'en'"
         (click)="languageService.switchLang('en')">
        English
      </a>
    </li>

    <li>
      <a class="dropdown-item" 
         *ngIf="languageService.currentLanguage !== 'ar'"
         (click)="languageService.switchLang('ar')">
        العربية
      </a>
    </li>
  </ul>
</div>
<button mat-icon-button class="notification mx-3" [routerLink]="['/notifications/list']">
        <span class="notification_dot" *ngIf="notificationService.unreadPushNotificationsCount>0"></span>
                    <i class="ri-notification-2-line"></i>
                </button>
      <div class="user-menu" data-bs-toggle="dropdown" mat-button [matMenuTriggerFor]="beforeMenuProfile">
        <i class="ri-user-line font-size-18px"></i>
        <span class="username font-weight-500 font-size-18px">
  {{
    languageService.currentLanguage === 'ar' 
      ? userService.currentUserCredantials?.arabicName 
      : userService.currentUserCredantials?.englishName
  }}
</span>

        <i class="ri-arrow-down-s-line font-size-18px"></i>
      </div>
      <mat-menu #beforeMenuProfile="matMenu" xPosition="before">
       
         <a class="dropdown-item" (click)="openChangePasswordDialog()" mat-menu-item>
          <i class="ri-lock-line mx-3"></i>
          <span>{{'ChangePassword.CHANGE_PASSWORD'|translate}}</span>
        </a>
        <a class="dropdown-item" (click)="openLogoutDialog()" mat-menu-item>
          <i class="ri-logout-box-r-line mx-3"></i>
          <span>{{'Home.SIGN_OUT'|translate}}</span>
        </a>
      </mat-menu>
    </div>
      </header>
  
      <section class="page-content">
        <!-- Content projected here -->
        <ng-content></ng-content>
      </section>
    </section>
  </div>
  <ng-template #logoutTemplateRef>
    <div class="logout-content">
      <img src="../../../assets/images/Switches-bro 1.svg" class="logout-img">
      <p class="my-3 font-weight-700 font-size-4 dark-color">{{ 'Home.LOGOUT_CONFIRMATION' | translate }}</p>
      <p class="mb-4 font-weight-700 font-size-4 color-red">{{ 'Home.SIGN_OUT' | translate }}</p>
      
      <div class="mx-3 my-3 d-flex justify-content-between align-items-center">
        <button class="no-button" (click)="closeLogoutDialog()">{{ 'Home.NO' | translate }}</button>
        <button class="yes-button" (click)="logOut()">{{ 'Home.YES' | translate }}</button>
      </div>
    </div>
  </ng-template>